/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import {
  addNewAxis,
  selectAxesToDisplay,
  selectRetrofitConfiguration,
  selectShowAxisPopup,
  setFiltersPopupOpened,
  selectNewAxisMode,
  setNewAxisMode,
  setAxesToDisplay
} from "../../../store/slices/retrofit";
import t from "../../../utils/common/translation/translator";
import AxisRecap from "../../../components/Retrofit/Devices/AxisRecap";
import FiltersPopup from "./FiltersPopup";
import useCheckMobileScreen from "../../../utils/common/useCheckMobileScreen";
import MsxIcons from "../../../components/common/Icons/MsxIcons/MsxIcons";
import { logEvent } from "../../../utils/common/api/api";
import AxisComponent from "../../../components/Retrofit/Axes/AxisComponent";
import { selectEventsData, updateConfiguration } from "../../../store/slices/common";

const Specify = () => {
  const configuration = useSelector(selectRetrofitConfiguration);
  const eventsData = useSelector(selectEventsData);
  const axestoDisplay = useSelector(selectAxesToDisplay);

  const newAxisMode = useSelector(selectNewAxisMode);
  const isMobile = useCheckMobileScreen();

  const dispatch = useDispatch();
  const addAxis = () => {
    dispatch(addNewAxis());
    dispatch(updateConfiguration());
    dispatch(setNewAxisMode(true));
    if (axestoDisplay === "with_bundle") {
      dispatch(setAxesToDisplay("all"));
    }
    logEvent(eventsData.locale, eventsData.types.addAxis, eventsData.tags.specifySelectRecap, configuration?.configId);
  };

  useEffect(() => {
    dispatch(setFiltersPopupOpened(false));
  }, []);

  const showAxisPopup = useSelector(selectShowAxisPopup);

  return (
    <div className={showAxisPopup ? "hidden" : ""}>
      <div className="axes-recap-wrapper flex flex-col space-y-3 mt-2 mb-32 md:mb-2">
        {configuration?.configData.axes.map((axis, index) => {
          const bundleSelected = axis.bundle.motorReference !== null && axis.bundle.motorReference !== undefined;
          const axisState = configuration?.configData?.axes.find((a) => a.id === axis.id)?.axisState;
          // check axes to display
          if (
            (axestoDisplay === "with_bundle" && !bundleSelected) ||
            (axestoDisplay === "without_bundle" && bundleSelected)
          ) {
            return null;
          }
          // if the bundle is not selected, show AxisComponent, otherwise show AxisRecap
          if (!bundleSelected && !axisState?.applicationDataFiltersApplied) {
            return (
              <AxisComponent
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                axisId={axis.id}
                // setFiltersPopupActiveTab={setFiltersPopupActiveTab}
                minimal={false}
                newAxis
              />
            );
          }
          return (
            (!newAxisMode || !isMobile) && (
              <AxisRecap
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                axis={axis}
              />
            )
          );
        })}
      </div>
      {isMobile && !newAxisMode && (
        <button
          type="button"
          onClick={() => addAxis()}
          className="fixed shadow bottom-20 right-6 inline-flex space-x-1 py-1 px-3 items-center justify-center rounded-full border-secondary border-[1px] bg-white text-secondary"
        >
          <MsxIcons name="add-flat" />
          <div className="flex items-center text-sm font-medium">{t("msizer.ui.axis")}</div>
        </button>
      )}
      {!isMobile && (
        <div
          id="retrofit-specify-button-add-axis"
          role="button"
          tabIndex={0}
          onClick={() => addAxis()}
          className="flex mb-20 bg-gray-50 border-[1px] border-solid border-gray-200 p-2 items-center justify-center space-x-1 text-secondary
 cursor-pointer transition-all duration-75 hover:bg-gray-100 select-none"
        >
          <IoIosAddCircleOutline className="text-base" />
          <span className=" text-sm">{t("msizer.ui.specify.add_axis_button_text")}</span>
        </div>
      )}
      <FiltersPopup />
    </div>
  );
};

export default Specify;
